/**
 * Format a date for sending to server (date-only, no time)
 * Returns YYYY-MM-DD string in Stockholm timezone context.
 *
 * @example
 * const date = window.dayjs.today()
 * date.formatDateForServer() // Returns "2024-01-15"
 */
export default (o, c, d) => {
    c.prototype.formatDateForServer = function () {
        // Ensure we're working in Stockholm timezone
        if (!this.tz()) {
            return this.tz('Europe/Stockholm').format('YYYY-MM-DD');
        }
        return this.format('YYYY-MM-DD');
    };
};
